import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { clinicInteriorImage, clinicPhone, clinicEmail } from '../mock';

const PrivacyPage = () => {
  return (
    <div className="App bg-white">
      <Header />
      <PageHero
        eyebrow="Patient Information"
        title="Privacy and"
        italic="care standards."
        description="Uptown Physiotherapy Clinic is guided by Ontario physiotherapy practice expectations, patient consent, confidentiality, and respectful patient-centred care."
        image={clinicInteriorImage}
        breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'Privacy & Standards' }]}
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-[900px] mx-auto px-6 space-y-10">
          <div>
            <h2 className="text-[28px] lg:text-[36px] font-bold tracking-tight text-neutral-900">Ontario physiotherapy standards</h2>
            <p className="mt-4 text-[15px] leading-relaxed text-neutral-700">
              Physiotherapy care in Ontario is regulated by the College of Physiotherapists of Ontario. Registered physiotherapists are expected to provide safe, ethical, competent, and patient-centred care. Patients may confirm a physiotherapist&apos;s registration through the College public register.
            </p>
          </div>

          <div>
            <h2 className="text-[24px] font-bold tracking-tight text-neutral-900">Consent and patient rights</h2>
            <p className="mt-4 text-[15px] leading-relaxed text-neutral-700">
              Patients have the right to understand the treatment being recommended, ask questions, give or refuse consent, and be treated with respect. Your physiotherapist will explain assessment findings, treatment options, expected benefits, possible risks, and any home program before proceeding.
            </p>
          </div>

          <div>
            <h2 className="text-[24px] font-bold tracking-tight text-neutral-900">Personal health information</h2>
            <p className="mt-4 text-[15px] leading-relaxed text-neutral-700">
              Patient information is handled as confidential health information. Information submitted through the website should be limited to what is needed for the clinic to contact you. Please call the clinic for urgent questions or sensitive health details.
            </p>
          </div>

          <div>
            <h2 className="text-[24px] font-bold tracking-tight text-neutral-900">Referrals, benefits, and coverage</h2>
            <p className="mt-4 text-[15px] leading-relaxed text-neutral-700">
              You can seek physiotherapy independently in Ontario. Some extended-health plans may still require a physician or nurse practitioner referral for reimbursement. Coverage, direct billing, WSIB, and motor-vehicle-accident claim handling depend on each plan, claim, and insurer.
            </p>
          </div>

          <div className="rounded-2xl border border-neutral-200 bg-neutral-50 p-6">
            <h2 className="text-[20px] font-bold tracking-tight text-neutral-900">Questions?</h2>
            <p className="mt-3 text-[15px] leading-relaxed text-neutral-700">
              Call <a href="tel:+15192522752" className="font-medium text-[#CA0028]">{clinicPhone}</a> or email{' '}
              <a href={`mailto:${clinicEmail}`} className="font-medium text-[#CA0028]">{clinicEmail}</a>.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
